export default "__VITE_ASSET__DNEExs1I__"